import * as cl from "classnames"
import * as React from "react"
import * as Model from "../../../../../model"

export default class CollectiviteField extends React.Component<Props> {
	static id = "local-authority-detail-bl-collectivite-gf"

	render() {
		const className = cl("select is-fullwidth", { "is-loading": this.props.loading })

		return <div className="field">
			<label className="label" htmlFor={CollectiviteField.id}>
				Collectivité de gestion financière
			</label>

			<span className="control">
				<span className={className}>
					<select
					disabled={this.props.loading || !this.props.collectivites.length}
					id={CollectiviteField.id}
					required
					value={this.props.value || ""}
					onChange={e => this.handleChange(e)}>
						{this.renderCollectivitesOptions()}
					</select>
				</span>
			</span>
		</div>
	}

	private handleChange(e: React.ChangeEvent<HTMLSelectElement>): void {
		const value = parseInt(e.target.value)
		this.props.onChange(value !== NaN ? value : null)
	}

	private renderCollectivitesOptions(): React.ReactNode {
		if (this.props.loading) return <option value="">Chargement...</option>

		if (!this.props.collectivites.length)
			return <option value="" disabled>
				Aucune collectivité de gestion financière disponible
			</option>

		const helpTitle = "Sélectionner une collectivité de gestion financière"

		const helpOption = <option disabled key={-1} title={helpTitle} value="">
			{helpTitle}
		</option>

		const collectivites = this.props.collectivites
		.sort((c1, c2) => c1.nom > c2.nom ? 1 : -1)

		const options = collectivites.map((c, i) =>
			<option key={i} title={c.nom} value={c.idCollectiviteGF}>{c.nom}</option>)

		return [helpOption, ...options]
	}
}

interface Props {
	collectivites: Model.BergerlevraultLocalauthority[];
	loading: boolean;
	value: number | null;
	onChange(value: number | null): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/collectivite-field.tsx